import { eventFormToQuery as formToQuery } from './eventFormToQuery';
import { eventFormToUpdateQuery as formToUpdateQuery } from './eventFormToUpdateQuery';
import { eventQueryToForm as queryToForm } from './eventQueryToForm';

export default {formToQuery, formToUpdateQuery, queryToForm}